import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormErrorsComponent } from 'src/app/components/form-errors/form-errors.component';
import { Country } from 'src/app/models/country/country';
import { CountryService } from 'src/app/services/country.service';

@Component({
  selector: 'app-country-modal',
  imports: [CommonModule, ReactiveFormsModule, FormErrorsComponent, MatDialogContent, MatDialogActions, MatDialogTitle],
  templateUrl: './country-modal.component.html',
  styleUrls: ['./country-modal.component.css']
})
export class CountryModalComponent implements OnInit{
  form: FormGroup = new FormGroup({});

  constructor(
    private fb: FormBuilder,
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<CountryModalComponent>,
    public CountryService: CountryService,
    public _toastService: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any    
  ) {
    
    this.buildForm();

    if(this.data?.item){
      this.form.patchValue({...this.data?.item}); 
    }
    if(this.data?.view){
      this.form.disable();
    }

  } 

  ngOnInit(): void {
    
  }

  private buildForm(){
    this.form = this.fb.group({
          id: new FormControl(0),
          name: new FormControl('', [Validators.required, Validators.maxLength(100)]),
          isEnabled: new FormControl(true)
    })
  }

  Accept() {
   
    const CountryModel = this.form?.value as Country;
   
    if(this.form.invalid) {
      this.form.markAllAsTouched();
      this._toastService.error("Por favor, complete todos los campos requeridos.");
      return;
    }

    if(this.data.mode == 'add' || this.data.mode == 'edit'){         
      this.save(CountryModel);  
    }else if(this.data.mode == 'delete'){
      this.delete(CountryModel.id);
    }
  }
  save(CountryModel: Country){    
    this.CountryService.addCountry(CountryModel).subscribe({
      next: (res:any) => {
        if(!res){this._toastService.error("Ha ocurrido un error inesperado"); return}        
        this._toastService.success("Datos guardados")
        this.closeDialog()
      }, error: (error: any) => {this._toastService.error('Ha ocurrido un error inesperado')}
    })
  }
  delete(id: number){    
    this.CountryService.deleteCountry(id).subscribe({
      next: (res:any) => {
        if(!res){this._toastService.error("Ha ocurrido un error inesperado"); return}        
        this._toastService.success("Datos eliminados correctamente!")
        this.closeDialog()
      }, error: (error: any) => {this._toastService.error('Ha ocurrido un error inesperado')}
    })
  }

  closeDialog(): void {
    this.dialogRef.close(true);
  }

}
